export interface RuntimeProfile {
  isMobile: boolean;
  isIOS: boolean;
  pixelRatio: number;
  minPixelRatio: number;
  antialias: boolean;
  preserveDrawingBuffer: boolean;
  stencil: boolean;
  shadowMapSize: number;
  shadowCascades: number;
  groundSubdivisions: number;
  markerRingSegments: number;
  ballSegments: number;
}

let profile: RuntimeProfile | null = null;

function detectIOS(userAgent: string): boolean {
  const platform = navigator.platform || '';
  return /iPad|iPhone|iPod/.test(userAgent) || (platform === 'MacIntel' && navigator.maxTouchPoints > 1);
}

export function getRuntimeProfile(): RuntimeProfile {
  if (profile) return profile;

  const userAgent = navigator.userAgent || '';
  const coarsePointer = window.matchMedia?.('(pointer: coarse)').matches ?? false;
  const narrowViewport = Math.min(window.innerWidth, window.innerHeight) < 820;
  const isMobile = coarsePointer || narrowViewport;
  const isIOS = detectIOS(userAgent);
  const pixelRatio = Math.min(window.devicePixelRatio || 1, isMobile ? 1.5 : 2);

  profile = {
    isMobile,
    isIOS,
    pixelRatio,
    minPixelRatio: isMobile ? 1 : 1.25,
    antialias: !isMobile,
    preserveDrawingBuffer: false,
    stencil: false,
    shadowMapSize: isMobile ? 1024 : 2048,
    shadowCascades: isMobile ? 2 : 4,
    groundSubdivisions: isMobile ? 24 : 64,
    markerRingSegments: isMobile ? 32 : 64,
    ballSegments: isMobile ? 16 : 32,
  };

  return profile;
}

export function installViewportSizing(): void {
  const setHeight = () => {
    const height = window.visualViewport?.height ?? window.innerHeight;
    document.documentElement.style.setProperty('--app-height', `${height}px`);
  };

  setHeight();
  window.addEventListener('resize', setHeight, { passive: true });
  window.addEventListener('orientationchange', setHeight, { passive: true });
  window.visualViewport?.addEventListener('resize', setHeight, { passive: true });
}
